// src/pages/AddLinkType.js
import React, { useState, useEffect } from "react";
import { useAuthCheck } from "../components/Auth";
import { api } from "../components/Api";
import { useNavigate } from "react-router-dom";

export default function AddLinkType() {
    const [typeLinkName, setTypeLinkName] = useState("");
    const [existingNames, setExistingNames] = useState([]);
    const navigate = useNavigate();
    const { checkToken } = useAuthCheck();

    useEffect(() => { checkToken(); }, [checkToken]);

    useEffect(() => {
        const fetchExistingNames = async () => {
            try {
                const res = await api.get("/type-links");
                setExistingNames(res.data.map(l => l.type_link_name));
            } catch (err) {
                console.error(err);
                alert("Erreur lors de la récupération des type links existants.");
            }
        };
        fetchExistingNames();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const name = typeLinkName.trim();
        if (!name) return alert("Le nom est obligatoire.");
        if (existingNames.includes(name)) return alert("Ce nom est déjà utilisé.");

        try {
            await api.post("/type-links", { type_link_name: name });
            alert("Type Link ajouté avec succès !");
            navigate("/linktype-list");
        } catch (err) {
            console.error(err);
            alert("Erreur lors de l'ajout du Type Link.");
        }
    };

    const token = localStorage.getItem("token");

    if (!token || localStorage.getItem("role") > 2) {
        navigate("/");
    }

    return (
        <div className="container mx-auto p-6 max-w-md">
            <h1 className="text-2xl font-bold mb-4 dark:text-white">Ajouter un Type Link</h1>
            <form onSubmit={handleSubmit} className="space-y-4 max-w-md">
                <div>
                    <label className="block mb-1 font-medium">Nom du Type Link</label>
                    <input
                        type="text"
                        value={typeLinkName}
                        onChange={(e) => setTypeLinkName(e.target.value)}
                        className="w-full border p-2 rounded dark:bg-gray-700 bg-white"
                        required
                    />
                </div>

                <button
                    type="submit"
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                    Ajouter
                </button>
            </form>
        </div>
    );
}
